// Modules
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';

import { DateInput, CheckboxInput } from 'components/forms/form-elements';
import { FormGroup } from 'components/forms/form-structure';
import { MetadataTable, MetadataItem } from 'components/content-containers/tables';
import { RateSelect, UserSelect } from 'components/forms/selects';
import { SHORT_HUMAN_DATE_FORMAT } from 'constants';
import { preventDefault } from 'utils/event-handlers';
import Person from 'services/data/person';
import Tooltip from 'components/widgets/overlays/tooltip';


class MetadataFormSection extends React.Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    agreement: PropTypes.object,
    formValues: PropTypes.object.isRequired,
    resetOnSubmit: PropTypes.bool,
    reset: PropTypes.func,
    showRate: PropTypes.bool,
    editing: PropTypes.object,
    users: PropTypes.array,
    currentUser: PropTypes.object,
    hideAgreement: PropTypes.bool,
    ticket: PropTypes.object
  };

  static defaultProps = {
    showRate: true
  };

  constructor() {
    super();
    this.state = {};

    this.editRate = this.editRate.bind(this);
    this.editDate = this.editDate.bind(this);
    this.editCreatedBy = this.editCreatedBy.bind(this);
  }

  editRate() {
    this.setState({ editingRate: true });
  }

  editCreatedBy() {
    this.setState({ editingCreatedBy: true });
  }

  editDate() {
    this.setState({ editingDate: true });
  }

  render() {
    const { editing, showRate, users, agreement, initialValues, ticket, formValues, currentUser, hideAgreement } = this.props;
    const { rate: defaultRateId, date: defaultDate, createdBy: defaultUserId } = initialValues;
    const { editingRate, editingDate, editingCreatedBy } = this.state;

    const defaultBillable = !editing && ticket && ticket.timeDefaultBillable;
    const agreementBillable = !ticket && agreement && agreement.timeDefaultBillable;
    const defaultUser = _.find(users, { id: defaultUserId });
    const defaultRate = _.find(agreement.rates, { id: defaultRateId });
    const isLead = Person.isLead(currentUser);

    return (
      <div>
        { !editing &&
          <div className="static-data time-report-static-data">
            <MetadataTable>
              { !hideAgreement &&
                <MetadataItem label="Agreement">
                  <Tooltip title="To use another agreement create a new ticket">{agreement.title}</Tooltip>
                </MetadataItem>
              }
              { !editingCreatedBy &&
                <MetadataItem label="User">
                  <span>{defaultUser.firstName} {defaultUser.lastName} </span>
                  { isLead && <a href="" onClick={preventDefault(this.editCreatedBy)}>Change</a> }
                </MetadataItem>
              }
              { !editingRate &&
                <MetadataItem label="Rate">
                  <span>
                    { (defaultBillable || agreementBillable) ?
                      `${defaultRate.role} - ${numeral(defaultRate.rate).format('$0,0[.]00')}` :
                      'Included in agreement - $0'
                    } <a href="" onClick={preventDefault(this.editRate)}>Change</a>
                  </span>
                </MetadataItem>
              }
              { !editingDate &&
                <MetadataItem label="Date">
                  <span>{moment(defaultDate).format(SHORT_HUMAN_DATE_FORMAT)} <a href="" onClick={preventDefault(this.editDate)}>Change</a></span>
                </MetadataItem>
              }
            </MetadataTable>
          </div>
        }
        { ((editingCreatedBy || editing) && isLead) && <Field component={UserSelect} name="createdBy" label="User" /> }
        { (editingRate || editing) && showRate &&
          <FormGroup label="Rate" className="rate-group">
            <Field
              component={RateSelect}
              name="rate"
              rates={agreement.rates}
              currentRate={_.get(editing, 'rate')}
              afterHoursPremium={formValues.afterHoursPremium}
              afterHours={formValues.afterHours}
            />
            <Field
              component={CheckboxInput}
              name="afterHours"
              label={`After Hours (+${numeral(formValues.afterHoursPremium).format('$0,0[.]00')}/hr)`}
            />
          </FormGroup>
        }
        { (editingDate || editing) && <Field component={DateInput} name="date" label="Date" /> }
      </div>
    );
  }
}

export default connect((state, ownProps) => ({
  formValues: formValueSelector(ownProps.form)(state, 'afterHours', 'rate', 'afterHoursPremium'),
  users: state.pageData.selectUsers,
  currentUser: state.auth.currentUser
}))(MetadataFormSection);
